<template>
  <div class="good-detail-box jd-detail-box">
    <van-nav-bar
      title="京东商品详情"
      fixed
      left-arrow
      @click-left="$router.go(-1)"
    />
    <van-swipe :autoplay="3000">
      <van-swipe-item v-for="(image, index) in images" :key="index">
        <div
          class="good-img"
          :style="{ 'background-image': 'url(' + image + ')' }"
        ></div>
      </van-swipe-item>
    </van-swipe>

    <div class="good-body">
      <div class="price-content">
        <div class="coupon-price">
          券后价：￥<span class="price">{{ price }}</span>
        </div>
        <div class="original-price">原价:￥{{ goodInfo.priceInfo.price || goodInfo.unitPrice }}</div>
        <div class="volume">
          已售 <span class="c-red">{{ goodInfo.inOrderCount30DaysSku ||  goodInfo.inOrderCount }}</span> 件
        </div>
      </div>
      <div class="name-content">
        <van-tag type="warning" v-if="goodInfo.isJdSale === 1"
          >京东自营</van-tag
        >
        <span class="name">
          {{ goodInfo.goodsName }}
        </span>
      </div>
      <!-- <div class="coupon-content">
        <van-tag plain size="large" type="danger">5元券剩余4000张</van-tag>
      </div> -->
      <!-- <div class="commission-content">
        <van-icon name="after-sale" /> 当前佣金
        <span class="commission">￥100 </span> 元
      </div> -->
      <div class="info">
        {{ goodInfo.kuadian_promotion_info }}<br />{{ goodInfo.play_info }}
      </div>
    </div>
    <div style="height: 55px"></div>
    <van-goods-action>
      <van-goods-action-icon
        icon="shop-o"
        text="首页"
        @click="$router.push('/')"
      />
      <!-- <van-goods-action-button
        type="warning"
        :text="`分享赚 ${promotion_rate} 元`"
        @click="doCopy"
      />
      <van-goods-action-button
        type="danger"
        :text="`立即买省 ${promotion_rate} 元`"
        @click="goBuy"
      /> -->
      <van-goods-action-button
        type="warning"
        text="分享"
        @click="doCopy"
      />
      <van-goods-action-button
        type="danger"
        text="立即买"
        @click="goBuy"
      />
    </van-goods-action>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      goodInfo: {
        priceInfo:{},
        commissionInfo:{},
      }, //商品详情
      images: [], //轮播图
    };
  },
  computed: {
    ...mapState(["rate"]),
    // 券后价
    price() {
      return this.goodInfo.priceInfo.lowestCouponPrice || this.goodInfo.unitPrice
    },
    // 佣金折算
    promotion_rate() {
     return (
        (this.goodInfo.commissionInfo.couponCommission *
          this.rate) /
        100
      ).toFixed(2);
    },
  },
  created() {
    const jdGoodInfo =
      JSON.parse(window.localStorage.getItem("jdGoodInfo")) || {};
    this.Post(
      { skuId: this.$route.query.id },
      "/jd/goodPromotiongoodsinfoQuery",
      (res) => {
        if (res.states == 1) {
          const data = JSON.parse(
            res.data.jd_union_open_goods_promotiongoodsinfo_query_response
              .result
          );
          if (data.code === 200) {
            let goodInfo = data.data[0] || {};
            if (goodInfo.skuId === jdGoodInfo.skuId) {
              goodInfo = {
                ...jdGoodInfo,
                ...goodInfo,
              };
            }
            this.goodInfo = goodInfo;
            console.log(goodInfo);
            if(goodInfo.imageInfo.imageList){
              this.images = goodInfo.imageInfo.imageList.map(item=>item.url)
            }else{
              this.images = [goodInfo.imgUrl]
            }
          }
        }
      }
    );
  },
  methods: {
    goBuy(){
      let url = this.goodInfo.materialUrl
      if(this.goodInfo.couponInfo.couponList){
         const couponList = this.goodInfo.couponInfo.couponList.sort((a,b)=>{
           return b.discount - a.discount
         })
          url = couponList[0].link;
      }
      window.location.href = url;
    },
    doCopy() {
       this.$router.push("/jd/share?id=" + this.goodInfo.skuId);
    },
  },
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import "../../assets/less/good.less";
</style>



// WEBPACK FOOTER //
// src/pages/jd/detail.vue